import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Inicializar i18n
import './i18n/config';
// Importar estilos de glow effect
import './glow-effect.css';
import { setupAnalyticsByConsent } from "./utils/analytics";

setupAnalyticsByConsent();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);